// src/components/profile/roi/ScenarioComparisonDashboard.jsx
import React from 'react';
import ScenarioCard from './ScenarioCard';  

export default function ScenarioComparisonDashboard({ 
  comparison, 
  activeScenario, 
  onSelect 
}) {
  const scenarioTitles = {
    conservative: 'Conservative',
    base: 'Base Case',
    aggressive: 'Aggressive'
  };
  
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Scenario Analysis
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {comparison.map(({ scenario, multiplier, model }) => (
          <ScenarioCard
            key={scenario}
            title={scenarioTitles[scenario]}
            scenarioKey={scenario}
            roiPct={model.headline.roiPct}
            paybackMonths={model.headline.paybackMonths}
            multiplier={multiplier}
            selected={activeScenario === scenario}
            onSelect={() => onSelect(scenario)}
          />
        ))}
      </div>
    </div>
  );
}